import React from 'react';
import { useAuth } from '../../../features/auth';
import { MainSidebar, useSidebar } from '../../../widgets/main-sidebar';
import { Topbar } from '../../../widgets/topbar';
import { TagsSection } from '../../admin/ui/sections/TagsSection';

const TagsPage: React.FC = () => {
  const { currentUser, logout } = useAuth();
  const { toggle } = useSidebar();

  if (!currentUser) return null;

  return (
    <div id="app-screen">
      <Topbar user={currentUser} onLogout={logout} onSidebarToggle={toggle} />
      <div className="app-body">
        <MainSidebar isAdmin={currentUser.role === 'ADMIN'} isManager={currentUser.role === 'MANAGER'} />
        <div className="app-content adm-content">
          <TagsSection />
        </div>
      </div>
    </div>
  );
};

export { TagsPage };
